/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_seo_jw_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a JSON Web Token to read its header and payload instantly. See the signing algorithm, inspect every claim, and get the issued-at and expiry timestamps converted to readable UTC — all decoded in your browser, with nothing uploaded.`)
};

const es_home_seo_jw_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega un JSON Web Token para leer su encabezado y carga útil al instante. Ver el algoritmo de firma, inspeccionar cada reclamación y obtener las marcas de tiempo de emisión y expiración convertidas a UTC legible, todo decodificado en tu navegador, sin nada cargado.`)
};

const de_home_seo_jw_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie ein JSON Web Token ein, um Header und Payload sofort zu lesen. Sehen Sie den Signaturalgorithmus, prüfen Sie jeden Claim und erhalten Sie Issued-at- und Ablaufzeitstempel als lesbares UTC-Datum — alles dekodiert in Ihrem Browser, ohne Upload.`)
};

const nl_home_seo_jw_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een JSON Web Token in om direct de header en payload te lezen. Zie het ondertekeningsalgoritme, inspecteer elke claim en krijg de uitgegeven-op- en vervaldatumstempels omgezet naar leesbare UTC — allemaal gedecodeerd in uw browser, zonder iets te uploaden.`)
};

const fr_home_seo_jw_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez un jeton JWT pour lire instantanément son en-tête et sa charge utile. Consultez l'algorithme de signature, inspectez chaque revendication et obtenez les horodatages d'émission et d'expiration convertis en UTC lisible — tout décodé dans votre navigateur, sans rien télécharger.`)
};

const it_home_seo_jw_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla un JSON Web Token per leggere istantaneamente la sua intestazione e payload. Vedi l'algoritmo di firma, ispeziona ogni rivendicazione e ottieni i timestamp di emissione e scadenza convertiti in UTC leggibile - tutto decodificato nel tuo browser, senza niente caricato.`)
};

const pt_br2_home_seo_jw_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole um JSON Web Token para ler seu cabeçalho e payload instantaneamente. Veja o algoritmo de assinatura, inspecione cada reivindicação e obtenha os timestamps de emissão e expiração convertidos para UTC legível — tudo decodificado no seu navegador, sem envio.`)
};

const pt_home_seo_jw_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole um JSON Web Token para ler o seu cabeçalho e carga instantaneamente. Veja o algoritmo de assinatura, inspecione cada reivindicação e obtenha os registos de tempo de emissão e expiração convertidos para UTC legível — tudo descodificado no seu navegador, sem nada ser enviado.`)
};

const ja_home_seo_jw_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Web Tokenを貼り付けてヘッダーとペイロードをすぐに読みます。シグネチャアルゴリズムを確認し、すべてのクレームを検査し、発行時刻と有効期限のタイムスタンプを読みやすいUTCに変換します — すべてブラウザでデコードされ、何もアップロードされません。`)
};

const zh_home_seo_jw_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴一个 JSON Web Token，即可立即读取其头部和载荷。查看签名算法、检查每一项声明，并将签发时间和过期时间戳转换为可读的 UTC 格式——全部在你的浏览器中解码，不会上传任何内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_seo_jw_p1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_seo_jw_p1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_seo_jw_p1", locale)
	if (locale === "en") return en_home_seo_jw_p1(inputs)
	if (locale === "es") return es_home_seo_jw_p1(inputs)
	if (locale === "de") return de_home_seo_jw_p1(inputs)
	if (locale === "nl") return nl_home_seo_jw_p1(inputs)
	if (locale === "fr") return fr_home_seo_jw_p1(inputs)
	if (locale === "it") return it_home_seo_jw_p1(inputs)
	if (locale === "pt-BR") return pt_br2_home_seo_jw_p1(inputs)
	if (locale === "pt") return pt_home_seo_jw_p1(inputs)
	if (locale === "ja") return ja_home_seo_jw_p1(inputs)
	return zh_home_seo_jw_p1(inputs)
};